"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventBus = /** @class */ (function () {
    function EventBus() {
        this.registrations = new Array();
    }
    EventBus.prototype.$on = function (event, callback) {
        var registration = { event: event, callback: callback };
        this.registrations.push(registration);
        return registration;
    };
    EventBus.prototype.$off = function (registration) {
        var i = this.registrations.findIndex(function (o) { return o === registration; });
        if (i >= 0)
            this.registrations.splice(i, 1);
    };
    EventBus.prototype.$emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // console.log(event, ...args);
        for (var _a = 0, _b = this.registrations; _a < _b.length; _a++) {
            var r = _b[_a];
            if (r && (!r.event || r.event === event)) {
                r.callback.apply(r, __spreadArray([event], args, false));
            }
        }
    };
    return EventBus;
}());
exports.default = EventBus;
//# sourceMappingURL=eventBus.js.map